import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button } from 'antd';
import classNames from 'classnames';
import { ReactComponent as TextLogo } from '@assets/images/igogo-text-logo.svg';
import { useAuthentication } from '@hooks/authentication';
import { useOkCancelDialog } from '@stores/okCancelDialogStore';
import { cdnImageUrl } from '@utils/image';
import { WEB_URL } from '@variables';

export const NavBar: React.FC<{
  hide?: boolean;
  landing?: boolean;
}> = (props) => {
  const navigate = useNavigate();
  const dialog = useOkCancelDialog();
  const { logout, authStore } = useAuthentication({ disableLoginRefresh: true });

  if (props.hide) {
    return <div></div>;
  }

  // const handleInquiryClick = () => {
  //   dialog.open({
  //     type: 'ok_cancel',
  //     title: '파트너스 문의',
  //     content:
  //       '[운영시간 : 평일 09:30 ~ 17:00]\n평일 오후 17시 이후의 문의는\n다음 영업일에 순차적으로 답변이 진행됩니다.',
  //     onConfirm: () => window.open(KAKAO_TUTOR_CENTER_URL, '_blank'),
  //     confirmText: '문의하기',
  //   });
  // };

  return (
    <header className={classNames('nav-bar')}>
      <div
        style={{
          width: '280px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80px',
        }}>
        <button
          className="link-button"
          onClick={(e) => {
            // 로그아웃 상태에서는 로그인 페이지로 이동
            if (!authStore?.user) {
              e.preventDefault();
              navigate('/login');
            } else {
              navigate('/dashboard');
            }
          }}>
          <TextLogo />
        </button>
        <div
          style={{
            width: '1px',
            height: '16px',
            backgroundColor: 'var(--Neutral-50, #B9BBBE)',
            margin: '0 16px',
          }}></div>
        <div
          style={{
            color: 'var(--Neutral-90, #424242)',
            fontFamily: 'Pretendard',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 700,
          }}>
          <Link to={'/'}>{authStore.user?.id ? '파트너센터' : '파트너스'}</Link>
        </div>
      </div>
      {!props.landing && (
        <div style={{ display: 'flex', gap: '28px', marginRight: '40px' }}>
          <button
            className="link-button"
            style={{
              color: 'var(--Neutral-90, #424242)',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
            }}
            onClick={() => {
              window.open(WEB_URL, '_blank');
            }}>
            아이고고 홈
          </button>
          <button
            className="link-button"
            onClick={() => {
              window.open('https://igogo.notion.site/1c796a81624b80808569e863fabfab8c?pvs=4', '_blank');
            }}
            style={{
              color: 'var(--Neutral-90, #424242)',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
            }}>
            사용가이드
          </button>
          {/* <button className="link-button" style={{ display: 'none' }}>
            <BellIcon />
          </button> */}
          <button
            className="link-button"
            style={{
              color: 'var(--Neutral-90, #424242)',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
            }}
            onClick={() => {
              dialog.open({
                title: '로그아웃',
                content: '로그아웃 할까요?',
                type: 'ok_cancel',
                onConfirm: () => {
                  logout();
                },
              });
            }}>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              {authStore.user?.profile?.imageUrl ? (
                <img
                  style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover' }}
                  src={cdnImageUrl(authStore.user?.profile?.imageUrl)}
                  alt=""
                />
              ) : (
                <Avatar size={32} icon={<UserOutlined />} />
              )}
              <div style={{ flexShrink: 0 }}>로그아웃</div>
            </div>
          </button>
        </div>
      )}
      {props.landing && (
        <div style={{ display: 'flex', gap: '28px', marginRight: '40px' }}>
          <button
            className="link-button"
            style={{
              color: 'var(--Neutral-90, #424242)',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
            }}
            onClick={() => {
              window.open(WEB_URL, '_blank');
            }}>
            아이고고 홈
          </button>
          <button
            className="link-button"
            style={{
              color: 'var(--Neutral-90, #424242)',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
            }}
            onClick={() => {
              navigate('/join');
            }}>
            파트너 신청
          </button>

          <button
            className="link-button"
            onClick={() => {
              window.open('https://igogo.notion.site/1c796a81624b805e85cac1c3835b6aa3?pvs=4', '_blank');
            }}
            style={{
              color: 'var(--Neutral-90, #424242)',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
            }}>
            예비 파트너 가이드
          </button>
          <Button
            style={{ height: '44px' }}
            onClick={() => {
              navigate('/login');
            }}>
            파트너센터 로그인
          </Button>
        </div>
      )}
    </header>
  );
};

export default NavBar;
